// =====================================================
// EVENT GUESTS REPOSITORY
// Stage 2: Participants & Pricing
// Repository wrapper for event guests service
// =====================================================

import * as eventGuestsService from '@/Services/eventGuests.service';
import type {
  EventGuest,
  CreateEventGuestData,
  UpdateEventGuestData,
} from '@/Services/eventGuests.service';

// ===================
// ERROR HANDLING WRAPPER
// ===================

async function withErrorHandling<T>(operation: () => Promise<T>): Promise<T> {
  try {
    return await operation();
  } catch (error) {
    console.error('Repository error:', error);
    throw error;
  }
}

// ===================
// EXPORTED FUNCTIONS
// ===================

export async function createEventGuest(data: CreateEventGuestData): Promise<EventGuest> {
  return withErrorHandling(() => eventGuestsService.createEventGuest(data));
}

export async function findOrCreateEventGuest(data: CreateEventGuestData): Promise<EventGuest> {
  return withErrorHandling(() => eventGuestsService.findOrCreateEventGuest(data));
}

export async function getEventGuestById(id: string): Promise<EventGuest | null> {
  return withErrorHandling(() => eventGuestsService.getEventGuestById(id));
}

export async function updateEventGuest(
  id: string,
  data: UpdateEventGuestData
): Promise<EventGuest> {
  return withErrorHandling(() => eventGuestsService.updateEventGuest(id, data));
}

export async function deleteEventGuest(id: string): Promise<void> {
  return withErrorHandling(() => eventGuestsService.deleteEventGuest(id));
}

export async function searchEventGuests(query: string): Promise<EventGuest[]> {
  return withErrorHandling(() => eventGuestsService.searchEventGuests(query));
}
